export default {
    namespaced: true,
    state: {
        officeReady: false
    },
    mutations: {
        SET_OFFICE_READY(state, isReady) {
            state.officeReady = isReady;
        }
    },
    actions: {
        setOfficeReady({ commit }, isReady) {
            commit('SET_OFFICE_READY', isReady);
        }
    },
    getters: {
        isOfficeReady: state => state.officeReady
    }
};
